<template>
  <div id="app">
    <Carousel class="carousel-component" />
    <Info class="info-component" />
  </div>
</template>

<script>
import Carousel from './components/Carousel'
import Info from './components/Info'

export default {
  name: 'App',
  components: {
    Carousel,
    Info
  }
}
</script>

<style>
@font-face {
  font-family: "eurasianormal";
  src: url("fonts/euran___-webfont.eot");
  src: url("fonts/euran___-webfont.eot?#iefix") format("embedded-opentype"),
    url("fonts/euran___-webfont.woff2") format("woff2"),
    url("fonts/euran___-webfont.woff") format("woff"),
    url("fonts/euran___-webfont.ttf") format("truetype"),
    url("fonts/euran___-webfont.svg#eurasianormal") format("svg");
  font-weight: normal;
  font-style: normal;
}

html,
body {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0;
  margin: 0;
  overflow: auto;
}

#app {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: "eurasianormal", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
